import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { Row, Col, Container, Spinner } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import copy from "copy-to-clipboard";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import Header from "../components/Header";
import SATextInput from "../components/SATextInput";
import StatesDropDown from "../components/StatesDropDown";
import PhoneNumber from "../components/PhoneNumber";
import AdvisorName from "../components/AdvisorName";
import BlockHeading from "../components/BlockHeading";
import BottomNavBar from "../components/BottomNavBar";
import StepAway from "../components/StepAway";
import DateComponent from "../components/DateComponents";
import moment from 'moment';
import toast, { toastConfig } from 'react-simple-toasts';
import * as educationAPI from "../services/currentEducation";
import SelectComponent from "../components/SelectComponent";

const educationData = [
    {
        id: 1,
        name: 'High School',
        value: 'High School'
    },
    {
        id: 2,
        name: 'College',
        value: 'College'
    }
]


export default function CurrentEducation() {
    const navigate = useNavigate();
    const location = useLocation();
    let [searchParams] = useSearchParams();

    const [loader, setLoader] = useState(false)
    const [copyUrl, setCopyUrl] = useState('');
    const [studHCode, setHexCode] = useState('');
    const [selectHighSchoolOrCollege, setSelectHighSchoolOrCollege] = useState('')
    const [getData, setGetData] = useState('')

    toastConfig({
        render: message => <div style={{ backgroundColor: '#cc2427', color: 'white', padding: 10, borderRadius: 10, fontSize: 18, fontWeight: '700' }}>{message}</div>,
    })
    
    useEffect(() => {
        document.title = 'Current Education | Families of WWII Veterans';
        window.scrollTo({ top: 0, behaviour: "smooth" })  
    }, []);
    useEffect(() => {
        let hexCode = location?.state?.hexCode ? location.state.hexCode : "";
        if (hexCode === "") {
            hexCode = searchParams.get("code");
        }
        setHexCode(hexCode);
        let modifiedURL = window.location.href.search("code")
        let url = ""
        if (modifiedURL > -1) {
            url = `${window.location.href}`
        } else {
            url = `${window.location.href}?code=${hexCode}`
        }
        setCopyUrl(url)
    }, [location?.state?.hexCode,searchParams]);
   
    

    const { register, handleSubmit, control, reset, watch, formState: { errors } } = useForm({
        defaultValues: {
            highSchoolOrCollege: 'High School',
            highSchoolName: '',
            highSchoolAddress1: '',
            highSchoolAddress2: '',
            highSchoolCity: '',
            highSchoolZipCode: '',
            graduationDate: '',
            highSchoolPhoneNumber: '',
            highSchoolState: '',
            schoolAdvisoryFirstName: '',
            schoolAdvisoryLastName: ''
        }
    });

    const getCurrentEducationApi = useCallback(async () => {
        setLoader(true)
        try {
            await educationAPI.getEducationInformation(`student/${studHCode}/education`).then((res) => {
                setLoader(false)
                if (res.status === 200) {
                    let currentEducationData = res.data;
                    let schoolOrCollegePhone = currentEducationData?.phoneNumber;
                    let schoolOrCollegeNumber = currentEducationData.phoneNumber ? "(" + schoolOrCollegePhone.slice(0, 3) + ")" + schoolOrCollegePhone.slice(3, 6) + "-" + schoolOrCollegePhone.slice(6, 10) : '';
                    setSelectHighSchoolOrCollege(currentEducationData.educationType)
                    setGetData(currentEducationData)
                    reset({
                        "highSchoolOrCollege": currentEducationData.educationType,
                        "highSchoolName": currentEducationData.name,
                        "highSchoolAddress1": currentEducationData.address,
                        "highSchoolAddress2": currentEducationData.address2,
                        "highSchoolCity": currentEducationData.city,
                        "highSchoolZipCode": currentEducationData.zipCode,
                        "graduationDate": moment(currentEducationData.graduationDate).format('MM/DD/YYYY'),
                        "highSchoolPhoneNumber": schoolOrCollegeNumber,
                        "highSchoolState": currentEducationData.state,
                        "schoolAdvisoryFirstName": currentEducationData.advisorFirstName,
                        "schoolAdvisoryLastName": currentEducationData.advisorLastName,
                    })
                } else {
                    if (res.status === 204) {
                        return
                    }
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                }
            })
                .catch(function (error) {
                    setLoader(false)
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                    return error
                });
        }
        catch (error) {
            setLoader(false)
            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
            return error
        }

    }, [reset,studHCode])

    useEffect(() => {
        if (studHCode) {
            getCurrentEducationApi()
        }
    }, [getCurrentEducationApi,studHCode]);

    const onSubmit = async (data) => {
        let currEduObj = {
            "educationType": data.highSchoolOrCollege,
            "name": data.highSchoolName,
            "address": data.highSchoolAddress1,
            "address2": data.highSchoolAddress2,
            "city": data.highSchoolCity,
            "state": data.highSchoolState,
            "zipCode": data.highSchoolZipCode,
            "graduationDate": moment(data.graduationDate).format('YYYY-MM-DD'),
            "phoneNumber": data.highSchoolPhoneNumber.toString().replace(/[^a-zA-Z0-9 ]/g, ''),
            "advisorFirstName": data.schoolAdvisoryFirstName,
            "advisorLastName": data.schoolAdvisoryLastName,
        }

        setLoader(true)
        try {
            await educationAPI.postEducationInformation(currEduObj, `student/${studHCode}/education`).then((res) => {
                setLoader(false)
                if (res.status === 200) {

                    navigate("/family", {
                        state: { hexCode: studHCode }
                    });
                } else if (res.status === 422) {

                    let errorData = res?.data?.errors
                    if (Object.keys(errorData) && Object.keys(errorData).length > 0) {
                        Object.keys(errorData).forEach((err) => {
                            toast(errorData[err][0], { position: 'top-right', backgroundColor: 'red' })
                        })
                    }
                } else {
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                }
            })
                .catch(function (error) {
                    setLoader(false)
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                    return error
                });
        }
        catch (error) {
            setLoader(false)
            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
        }
    }

    const handleBack = () => {
        navigate("/", {
            state: { hexCode: studHCode }
        })
    }
    const handleNavBack = (to) => {
        navigate(to, {
            state: { hexCode: studHCode }
        })
    }
    const handleCopy = () => {
        copy(copyUrl);
        alert(`URLGOESHERE copied to your clipboard. Save this URL.`);
    }

    const watchFields = watch(["highSchoolOrCollege"]);
    useEffect(() => {
        if (watchFields[0] === 'High School') {
            setSelectHighSchoolOrCollege('High School')
            if (selectHighSchoolOrCollege === 'College') {
                reset({
                    highSchoolName: '',
                    highSchoolAddress1: '',
                    highSchoolAddress2: '',
                    highSchoolCity: '',
                    highSchoolZipCode: '',
                    graduationDate: '',
                    highSchoolPhoneNumber: '',
                    highSchoolState: '',
                    schoolAdvisoryFirstName: '',
                    schoolAdvisoryLastName: '',
                })
            }

            if (selectHighSchoolOrCollege === 'College' && getData && getData?.educationType === 'High School') {
                let schoolOrCollegePhone = getData?.phoneNumber;
                let schoolOrCollegeNumber = getData.phoneNumber ? "(" + schoolOrCollegePhone.slice(0, 3) + ")" + schoolOrCollegePhone.slice(3, 6) + "-" + schoolOrCollegePhone.slice(6, 10) : '';

                reset({
                    "highSchoolName": getData.name,
                    "highSchoolAddress1": getData.address,
                    "highSchoolAddress2": getData.address2,
                    "highSchoolCity": getData.city,
                    "highSchoolZipCode": getData.zipCode,
                    "graduationDate": moment(getData.graduationDate).format('MM/DD/YYYY'),
                    "highSchoolPhoneNumber": schoolOrCollegeNumber,
                    "highSchoolState": getData.state,
                    "schoolAdvisoryFirstName": getData.advisorFirstName,
                    "schoolAdvisoryLastName": getData.advisorLastName,
                })
            }
        }
        else if (watchFields[0] === 'College') {
            setSelectHighSchoolOrCollege('College')
            if (selectHighSchoolOrCollege === 'High School') {

                reset({
                    highSchoolOrCollege: 'College',
                    highSchoolName: '',
                    highSchoolAddress1: '',
                    highSchoolAddress2: '',
                    highSchoolCity: '',
                    highSchoolZipCode: '',
                    graduationDate: '',
                    highSchoolPhoneNumber: '',
                    highSchoolState: '',
                    schoolAdvisoryFirstName: '',
                    schoolAdvisoryLastName: '',
                })

            }
            if (selectHighSchoolOrCollege === 'High School' && getData && getData?.educationType === 'College') {
                let schoolOrCollegePhone = getData?.phoneNumber;
                let schoolOrCollegeNumber = getData.phoneNumber ? "(" + schoolOrCollegePhone.slice(0, 3) + ")" + schoolOrCollegePhone.slice(3, 6) + "-" + schoolOrCollegePhone.slice(6, 10) : '';

                reset({
                    "highSchoolOrCollege": getData.educationType,
                    "highSchoolName": getData.name,
                    "highSchoolAddress1": getData.address,
                    "highSchoolAddress2": getData.address2,
                    "highSchoolCity": getData.city,
                    "highSchoolZipCode": getData.zipCode,
                    "graduationDate": moment(getData.graduationDate).format('MM/DD/YYYY'),
                    "highSchoolPhoneNumber": schoolOrCollegeNumber,
                    "highSchoolState": getData.state,
                    "schoolAdvisoryFirstName": getData.advisorFirstName,
                    "schoolAdvisoryLastName": getData.advisorLastName,
                })
            }
        }
    }, [watchFields,reset,selectHighSchoolOrCollege,getData])


    return (
        <>
            <Header title="Scholarship Applications" />
            {loader && <div lg={12} md={12} sm={12} className="loaderContainer">
                <Spinner animation="border" variant="primary" /> </div>}
            <Container className='py-3 py-md-4 py-md-5'>
                <Row>
                    <Col lg={12}>
                        <StepAway handleCopy={handleCopy} copyInputValue={copyUrl} />
                        <Nav navbType="student" handleNavBack={handleNavBack} />
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <BlockHeading title="Current Education" />
                            <Row>
                                <Col lg={4}>
                                    <SelectComponent
                                        selectOption={true}
                                        register={register}
                                        errors={errors}
                                        data={educationData}
                                        isStrong={true}
                                        htmlFor={"highSchoolOrCollege"}
                                        label={"High School or College:"}
                                        name={"highSchoolOrCollege"}
                                        errMsg={errors?.highSchoolOrCollege?.message}
                                        id={"highSchoolOrCollegeHelp"}
                                        requiredObj={{ required: "High School or College required" }}
                                    />
                                </Col>
                                <Col lg={8}>
                                    <SATextInput
                                        register={register}
                                        htmlFor={'highSchoolName'}
                                        name={'highSchoolName'}
                                        label={selectHighSchoolOrCollege === 'High School' ? "High School Name:" : 'College Name:'}
                                        isStrong={true}
                                        type={"text"}
                                        placeholder={selectHighSchoolOrCollege === 'High School' ? "High School Name (required)" : 'College Name (required)'}
                                        errors={errors}
                                        id={'HighSchoolNameHelp'}
                                        errMsg={errors.highSchoolName?.message}
                                        maxLength={64}
                                        requiredObj={{
                                            required: selectHighSchoolOrCollege === 'High School' ? "High School Name is required!" : "College Name is required!",
                                            pattern: {
                                                value: /[\sa-zA-Z'`~.s -]+$/,
                                                message: selectHighSchoolOrCollege === 'High School' ? "Invalid High School Name!" : "Invalid College Name!"
                                            }
                                        }}
                                    />
                                </Col>
                                <Col lg={8}>
                                    <SATextInput
                                        register={register}
                                        htmlFor={'highSchoolAddress1'}
                                        name={'highSchoolAddress1'}
                                        label={selectHighSchoolOrCollege === 'High School' ? "High School Address:" : 'College Address:'}
                                        isStrong={true}
                                        type={"text"}
                                        placeholder={selectHighSchoolOrCollege === 'High School' ? "High School Address (required)" : "College Address (required)"}
                                        errors={errors}
                                        id={'HighSchoolAddress1Help'}
                                        errMsg={errors.highSchoolAddress1?.message}
                                        maxLength={250}
                                        requiredObj={{
                                            required: selectHighSchoolOrCollege === 'High School' ? "High School Address is required!" : "College Address is required!",
                                            pattern: {
                                                value: /[\sa-zA-Z0-9.s',#/@ -/&]+$/,
                                                message: selectHighSchoolOrCollege === 'High School' ? "Invalid High School Address!" : "Invalid College School Address!"
                                            }
                                        }}
                                    />
                                </Col>
                                <Col lg={4}>
                                    <SATextInput
                                        register={register}
                                        htmlFor={'highSchoolAddress2'}
                                        name={'highSchoolAddress2'}
                                        label={selectHighSchoolOrCollege === 'High School' ? "High School Address 2:" : "College Address 2:"}
                                        isStrong={false}
                                        type={"text"}
                                        placeholder={selectHighSchoolOrCollege === 'High School' ? "High School Address 2" : "College Address 2"}
                                        errors={errors}
                                        maxLength={100}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6}>
                                    <SATextInput
                                        register={register}
                                        htmlFor={'highSchoolCity'}
                                        name={'highSchoolCity'}
                                        label={selectHighSchoolOrCollege === 'High School' ? "High School City:" : 'College City:'}
                                        placeholder={selectHighSchoolOrCollege === 'High School' ? "High School City (required)" : 'College City (required)'}
                                        isStrong={true}
                                        type={"text"}
                                        errors={errors}
                                        id={'cityHelp'}
                                        errMsg={errors.highSchoolCity?.message}
                                        maxLength={32}
                                        requiredObj={{
                                            required: selectHighSchoolOrCollege === 'High School' ? "High School City is required!" : "College City (required)",
                                            pattern: {
                                                value: /(^[a-zA-Z-.'\s]*$)/,
                                                message: selectHighSchoolOrCollege === 'High School' ? "Invalid High School City!" : "Invalid College City!"
                                            }
                                        }}
                                    />
                                </Col>

                                <Col lg={3}>
                                    <StatesDropDown
                                        label={selectHighSchoolOrCollege === 'High School' ? "High School State:" : 'College State:'}
                                        register={register}
                                        errors={errors}
                                        htmlFor={'highSchoolHtmlFor'}
                                        name={'highSchoolState'}
                                        id={'highSchoolStateHelp'}
                                        errMsg={errors.highSchoolState?.message}
                                        requiredObj={{
                                            required: selectHighSchoolOrCollege === 'High School' ? "High School State is required!" : "College State is required!"
                                        }}
                                    />
                                </Col>

                                <Col lg={3}>
                                    <SATextInput
                                        register={register}
                                        htmlFor={'highSchoolZipCode'}
                                        name={'highSchoolZipCode'}
                                        label={selectHighSchoolOrCollege === 'High School' ? "High School ZIP Code:" : 'College ZIP Code:'}
                                        placeholder={selectHighSchoolOrCollege === 'High School' ? "High School ZIP Code (required)" : 'College ZIP Code (required)'}
                                        isStrong={true}
                                        type={"text"}
                                        errors={errors}
                                        id={'ZipCodeHelp'}
                                        errMsg={errors.highSchoolZipCode?.message}
                                        requiredObj={{
                                            required: selectHighSchoolOrCollege === 'High School' ? "High School ZIP Code is required!" : "College ZIP Code is required!",
                                            pattern: {
                                                value: /^[0-9]{5}$/,
                                                message: selectHighSchoolOrCollege === 'High School' ? "Invalid High School ZIP Code!" : "Invalid College ZIP Code!"
                                            }
                                        }}
                                        maxLength={"5"}
                                    />
                                </Col>
                            </Row>
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="form-group">
                                        <DateComponent
                                            label={"Graduation Date:"}
                                            control={control}
                                            htmlFor={"graduationDate"}
                                            name={"graduationDate"}
                                            isStrong={true}
                                            required={"Graduation Date is required!"}
                                            invalidMessage={"Invalid Graduation Date!"}
                                            placeholder={"Graduation Date: mm/dd/yyyy"}
                                            id={"graduationDateHelp"}
                                            errMsg={errors.graduationDate?.message}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <PhoneNumber
                                        register={register}
                                        errors={errors}
                                        control={control}
                                        htmlFor={"highSchoolPhoneNumber"}
                                        name={"highSchoolPhoneNumber"}
                                        isStrong={true}
                                        label={selectHighSchoolOrCollege === 'High School' ? "High School Phone Number:" : "College Phone Number:"}
                                        requiredObj={{
                                            required: selectHighSchoolOrCollege === 'High School' ? "High School Phone is required!" : "College Phone is required!",
                                            pattern: {
                                                value: /\([0-9]{3}\)[0-9]{3}-[0-9]{4}/,
                                                message: selectHighSchoolOrCollege === 'High School' ? "Invalid High School Phone Number!" : "Invalid College Phone Number!"
                                            }
                                        }}
                                        maskValue={"(999)999-9999"}
                                        type={"tel"}
                                        placeholder={selectHighSchoolOrCollege === 'High School' ? "High School Phone Number (required)" : "College Phone Number (required)"}
                                        id={"highSchoolPhoneNumberHelp"}
                                        errMsg={errors.highSchoolPhoneNumber?.message}
                                    />
                                </div>
                            </div>
                            <hr />
                            <h4 className="text-secondary"><strong>Counselor/Advisor Name</strong></h4>
                            <AdvisorName
                                register={register}
                                errors={errors}
                                firstNameHtmlFor={"schoolAdvisorFirstName"}
                                nameForFirstName={"schoolAdvisoryFirstName"}
                                firstNameId={"schoolAdvisoryFirstNameHelp"}
                                firstNameErrMsg={errors.schoolAdvisoryFirstName?.message}
                                lastNameHtmlFor={"schoolAdvisorLastName"}
                                nameForLastName={"schoolAdvisoryLastName"}
                                lastNameId={"schoolAdvisoryLastNameHelp"}
                                lastNameErrMsg={errors.schoolAdvisoryLastName?.message}
                            />
                            <hr />
                            <BottomNavBar handleBack={handleBack}
                                submitButtonTitle="NEXT" />
                        </form>
                    </Col>
                </Row>
            </Container>
            <Footer />
        </>
    );
}